import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosProperty, throwResponse } from "config/axios";
import { IDashboardGraph, IDashboardParams } from "../../interface";
import { IComplaint, IComplaintGraph } from "./interface";

export const useGetPropertyDashBoardComplaint = (
  params?: IDashboardParams
): UseQueryResult<IComplaint[], Error> => {
  return useQuery(
    ["dashboard-property-complaint", "count-on-status", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/feedback/count-on-status",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    }
  );
};

export const useGetPropertyDashBoardComplaintGraph = (
  params?: IDashboardParams
): UseQueryResult<IDashboardGraph[], Error> => {
  return useQuery(
    ["dashboard-property-complaint", "graph-count-on-month", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/feedback/graph-count-on-month",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    }
  );
};

export const useGetPropertyDashBoardComplaintGraphSettingType = (
  params?: IDashboardParams
): UseQueryResult<IComplaintGraph[], Error> => {
  return useQuery(
    ["dashboard-property-complaint", "graph-status-by-setting-type", params],
    async () => {
      const res = await axiosProperty.get(
        "/dashboard/feedback/graph-status-by-setting-type",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    }
  );
};
